import { render, staticRenderFns } from "./auth-details.component.vue?vue&type=template&id=d7d80e2c&scoped=true"
import script from "./auth-details.component.vue?vue&type=script&lang=js"
export * from "./auth-details.component.vue?vue&type=script&lang=js"
import style0 from "./auth-details.component.vue?vue&type=style&index=0&id=d7d80e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d80e2c",
  null
  
)

export default component.exports